import { stats } from '@/mocks/testimonials';

export default function Stats() {
  return (
    <section className="py-16 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-background-50/15 flex items-center justify-center">
                <i className={`${stat.icon} text-2xl text-background-50`}></i>
              </div>
              <p className="text-3xl md:text-4xl font-bold text-background-50 mb-2">{stat.value}</p>
              <p className="text-sm text-background-50/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}